import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../_config/restapis';
import { map } from 'rxjs/operators';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class APIURLRegisterService {

    constructor(
        private http: HttpClient,
        private db: $DBManagerService,
        private evt: $BroadcastManagerService
    ) { }


    public GetEntityId(entityId): Observable<any> {
        console.log(APIConstants.GETENTITYID + '/' + entityId);
        return this.http.get(APIConstants.GETENTITYID + '/' + entityId);
    }

    //EntityName
    public GetEntityName(entityName): Observable<any> {
        console.log(APIConstants.GETENTITYNAME + '/' + entityName);
        return this.http.get(APIConstants.GETENTITYNAME + '/' + entityName);
    }

    public addNewurlApi(data): Observable<any> {
        return this.http.post(APIConstants.URLREGISTERBYPE, data);
    }

    public urlRegisterList(data): Observable<any> {
        return this.http.post(APIConstants.URLREGISTERLIST, data);
    }

    public downloadUrlblobFile(file1): Observable<any> {
        return this.http.post(APIConstants.URLFILEDOWNLOADBLOB, file1, { responseType: "blob" });
    } 

    public getUrlDetailsRegbyurn(data): Observable<any> {
        return this.http.post(APIConstants.GETURLDETBYURN, data);
    }

    public urlWhitelistRegistraAction(data): Observable<any> {
        return this.http.post(APIConstants.UPDATEURLREGISTRARACTION, data);
    }
    
    public urlWhitelistRegSummary(data): Observable<any> {
        return this.http.post(APIConstants.URLSUMMARYREG, data);
    }

    public downloadUrlWorklistFile(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADURLSUMMARYPE, data, { responseType: "blob" });
    }
    
    public downloadUrlRegSummaryFile(data): Observable<any> {
        return this.http.post(APIConstants.DOWNLOADURLSUMMARYREG, data, { responseType: "blob" });
    }
    public listPrincipalEntityHeaderSMSDLT(data): Observable<any>{
        return this.http.get(APIConstants.LISTPRINCIPLEENTITYHEADERSMSDLT + '/' +data);
    } 

}
